import { MainStore, useMainStore } from '../MainStore';
import { ToastStore, useToastStore } from '../ToastStore';

export interface UseTask {
   run: (
      task: () => Promise<any>,
      showError?: boolean,
      onError?: (e: any) => void,
      onFinally?: () => void,
   ) => Promise<any>;
}

export function useTask(): UseTask {
   const setLoading = useMainStore((state: MainStore) => state.setLoading);
   const toast = useToastStore((state: ToastStore) => ({
      setMessage: state.setMessage,
      setHelperText: state.setHelperText,
   }));

   async function run(
      task: () => any,
      showError: boolean = true,
      onError?: (e: any) => void,
      onFinally?: () => void,
   ): Promise<any> {
      let res: boolean = false;

      try {
         setLoading(true);
         const result = await task();

         if (result !== undefined) {
            res = result;
         } else {
            res = true;
         }
      } catch (e: any) {
         console.error(e);

         if (showError) {
            let message: string;
            if (e.error) {
               message = e.error;
            } else if (e.data && e.data.error) {
               message = e.data.error;
            } else if (e.message) {
               message = e.message;
            } else {
               message = JSON.stringify(e);
            }

            toast.setMessage(message, 'error');

            if (e.data) {
               toast.setHelperText(JSON.stringify(e.data, null, 2));
            }
         }

         if (onError) {
            onError(e);
         }
      } finally {
         setLoading(false);

         if (onFinally) {
            onFinally();
         }
      }

      return res;
   }

   return {
      run,
   };
}
